import client from './client-promise'

let ad_data = JSON.parse(document.querySelector('#share_data').innerHTML);
console.log(ad_data);

function decodeEntities(encodedString) {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = encodedString;
    return textArea.value;
}

if(client.isiOS() || client.getSafari() || client.isAndroid()){
    setTimeout(function () {
        try {
            client.activityDetails(
                ad_data.sns_share_title,
                ad_data.sns_share_description || '',
                ad_data.sns_share_media_url,
                decodeEntities(ad_data.target_url))
        }catch(err) {
            console.log(err);
            location.href = decodeEntities(ad_data.target_url)
        }
    }, 500);
    setTimeout(function () {
        location.href = decodeEntities(ad_data.target_url)
    }, 1000)

}





// WEBPACK FOOTER //
// ./resources/assets/redirect/app.js